@use "variables" as *;

.badgeDiv {
  display: flex;
  width: 42px;
  align-items: center;
  justify-content: center;
}

.badge {
  width: 24px !important;
  height: 24px !important;
}

.name {
  font-size: $fontSize-m;
  font-weight: normal;
  margin-right: $spacing-m !important;
}
